var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    focusable: "false",
    color: "var(--token-7bc77d28-260e-4b84-92a3-3084b520b0ce, rgb(255, 255, 255))",
    style: {
      userSelect: "none",
      width: "100%",
      height: "100%",
      display: "inline-block",
      fill: "var(--token-7bc77d28-260e-4b84-92a3-3084b520b0ce, rgb(255, 255, 255))",
      color: "var(--token-7bc77d28-260e-4b84-92a3-3084b520b0ce, rgb(255, 255, 255))",
      flexShrink: 0
    },
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    color: "var(--token-7bc77d28-260e-4b84-92a3-3084b520b0ce, rgb(255, 255, 255))",
    weight: "regular",
    fill: "#FFFCF5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104,216a16,16,0,1,1-16-16A16,16,0,0,1,104,216Zm88-16a16,16,0,1,0,16,16A16,16,0,0,0,192,200ZM239.71,74.14l-25.64,92.28A24.06,24.06,0,0,1,191,184H92.16A24.06,24.06,0,0,1,69,166.42L33.92,40H16a8,8,0,0,1,0-16H40a8,8,0,0,1,7.71,5.86L57.19,64H232a8,8,0,0,1,7.71,10.14ZM221.47,80H61.64l22.81,82.14A8,8,0,0,0,92.16,168H191a8,8,0,0,0,7.71-5.86Z",
    fill: "#FFFCF5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcom);
export default __webpack_public_path__ + "static/media/ecom.bc6107b85043753644038c365831f100.svg";
export { ForwardRef as ReactComponent };